@use '@/styles/tokens' as *;

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.label {
  font-size: 13px;
  font-weight: var(--font-weight-medium);
  color: var(--text-secondary);
}

.hint {
  font-size: 13px;
  color: var(--text-muted);
}
